// extracted by mini-css-extract-plugin
export default {"list-of-candidates":"GuestDashboard_list-of-candidates__tWUJu","create-job":"GuestDashboard_create-job__PbA0V"};